"use strict";
angular.module("pgcUserInformationServiceModule", [
  "pgcUserDetailsModule", //用户详细信息
  "editUserModule", //编辑用户
  "channelManagementAddModule", //渠道管理操作
  // "noChannelTipsModule", //渠道没有提示
]).
factory("pgcUserInformationService", ["$modal", "$q", function ($modal, $q) {
  return {

    /**
     * [pgcUserDetails description] 用户详细信息
     * @param {[string]} [content] [description] 内容
     */
    pgcUserDetails: function (userId) {
      var deffer = $q.defer();
      var modalInstance = $modal.open({
        templateUrl: "./main/backstage/userManagement/pgcUserInformation/service/pgcUserDetails/pgcUserDetails_tpl.html",
        windowClass: 'pgcUserDetails backstageModalHeader',
        backdrop: false,
        controller: "pgcUserDetailsCtrl",
        resolve: {
          userId: function () {
            return userId;
          }
        }
      });
      modalInstance.result.then(function (result) {
        deffer.resolve(result);
      });
      return deffer.promise;
    },
    /**
     * [pgcUserDetails description] 编辑用户
     * @param {[string]} [content] [description] 内容
     */
    editUser: function (userId) {
      var deffer = $q.defer();
      var modalInstance = $modal.open({
        templateUrl: "./main/backstage/userManagement/pgcUserInformation/service/editUser/editUser_tpl.html",
        windowClass: 'editUser backstageModalHeader',
        backdrop: false,
        controller: "editUserCtrl",
        resolve: {
          userId: function () {
            return userId;
          }
        }
      });
      modalInstance.result.then(function (result) {
        deffer.resolve(result);
      });
      return deffer.promise;
    },
    /**
     * [createProduct description] 角色设置
     * @param {[string]} [content] [description] 内容
     */
    roleSetting: function (userId) {
      var deffer = $q.defer();
      var modalInstance = $modal.open({
        templateUrl: "./main/backstage/userManagement/userInformation/service/roleSetting/roleSetting_tpl.html",
        windowClass: 'roleSetting backstageModalHeader',
        backdrop: false,
        controller: "roleSettingCtrl",
        resolve: {
          userId: function () {
            return userId;
          }
        }
      });
      modalInstance.result.then(function (result) {
        deffer.resolve(result);
      });
      return deffer.promise;
    },
    /**
     * 渠道数据
     * 渠道数据处理是否删除
     */
    channelManagement: function (id) {
      var deffer = $q.defer();
      var modalInstance = $modal.open({
        templateUrl: "./main/backstage/userManagement/pgcUserInformation/service/channelManagementAdd/channelManagementAdd_tpl.html",
        windowClass: 'channel backstageModalHeader',
        backdrop: false,
        controller: "channelManagementAddCtrl",
        resolve: {
          channleId: function () {
            return id;
          }
        }
      });
      modalInstance.result.then(function (result) {
        deffer.resolve(result);
      });
      return deffer.promise;
    },
    /**
     *渠道信息没有提示 
     */
    // noTips: function (content1, content2) {
    //   var deffer = $q.defer();
    //   var modalInstance = $modal.open({
    //     templateUrl: "./main/backstage/userManagement/pgcUserInformation/service/noChannelTips/noChannelTips_tpl.html",
    //     windowClass: 'noTips',
    //     backdrop: false,
    //     controller: "noChannelTipsCtrl",
    //     resolve: {
    //       content: function () {
    //         return {
    //           content1: content1,
    //           content2: content2
    //         };
    //       }
    //     }
    //   });
    //   modalInstance.result.then(function (result) {
    //     deffer.resolve(result);
    //   });
    //   return deffer.promise;
    // }
  };
}]);
